import { render, staticRenderFns } from "./DetailResult.vue?vue&type=template&id=7dcc994f&scoped=true&"
import script from "./DetailResult.vue?vue&type=script&lang=js&"
export * from "./DetailResult.vue?vue&type=script&lang=js&"
import style0 from "./DetailResult.vue?vue&type=style&index=0&id=7dcc994f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc994f",
  null
  
)

export default component.exports